import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, IndianRupee, ArrowUpRight } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

export const TaskCard = ({ task, showMatch = false, testId }) => (
  <div data-testid={testId || `task-card-${task.id}`} className="card-surface card-hover p-5 flex flex-col gap-4">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="flex items-center gap-2 text-xs text-zinc-500 mb-1">
          <span className="font-mono">{task.id}</span>
          <span>·</span>
          <span>{task.category}</span>
        </div>
        <h3 className="font-display text-lg font-medium text-white leading-snug truncate">{task.title}</h3>
        <p className="text-sm text-zinc-500 mt-1">{task.company}</p>
      </div>
      <StatusBadge status={task.status} />
    </div>

    <div className="flex flex-wrap gap-1.5">
      {task.skills.slice(0, 4).map(s => (
        <span key={s} className="text-[11px] px-2 py-0.5 rounded-full border text-zinc-300"
              style={{ borderColor: "var(--border-strong)", background: "var(--surface-2)" }}>
          {s}
        </span>
      ))}
    </div>

    <div className="grid grid-cols-3 gap-3 pt-3 border-t" style={{ borderColor: "var(--border)" }}>
      <div className="min-w-0">
        <div className="eyebrow mb-1">Location</div>
        <div className="text-xs text-zinc-300 flex items-center gap-1 truncate"><MapPin size={11}/><span className="truncate">{task.distance === "Remote" ? "Remote" : task.location.split(",")[0]}</span></div>
      </div>
      <div>
        <div className="eyebrow mb-1">Budget</div>
        <div className="text-xs text-white font-mono flex items-center"><IndianRupee size={11}/>{task.budget.toLocaleString()}</div>
      </div>
      <div>
        <div className="eyebrow mb-1">Deadline</div>
        <div className="text-xs text-zinc-300 flex items-center gap-1"><Clock size={11}/>{task.deadline.split(",")[0]}</div>
      </div>
    </div>

    <div className="flex items-center justify-between pt-2">
      {showMatch ? (
        <div className="flex items-center gap-2">
          <div className="relative w-9 h-9 rounded-full flex items-center justify-center"
               style={{ background: "conic-gradient(#3B82F6 " + (task.matchScore * 3.6) + "deg, #1E1E22 0)" }}>
            <div className="w-7 h-7 rounded-full bg-[#0A0A0C] flex items-center justify-center">
              <span className="text-[10px] font-mono text-blue-400">{task.matchScore}</span>
            </div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500">Match</div>
            <div className="text-xs text-zinc-300">Strong fit</div>
          </div>
        </div>
      ) : (
        <div className="text-xs text-zinc-500">{task.applications != null ? `${task.applications} applications · ` : "Posted "}{task.posted}</div>
      )}
      <Link to={`/student/tasks/${task.id}`} data-testid={`apply-btn-${task.id}`}
            className="inline-flex items-center gap-1 text-sm text-blue-400 hover:text-blue-300 transition-colors duration-200">
        View <ArrowUpRight size={13}/>
      </Link>
    </div>
  </div>
);

export default TaskCard;
